const corporateResidence = {
  'corporateResidence.page.lastUpdated': '最終更新: 2026年6月13日',
  'corporateResidence.page.backToTop': 'ページトップへ戻る',
  'corporateResidence.jsonld.serviceName': '高級レジデンス向け接遇研修｜コンシェルジュ・フロントの接遇品質を統一',
  'corporateResidence.jsonld.orgName': '一般社団法人全日本執事協会',
  'corporateResidence.jsonld.serviceType': '高級レジデンス向け接遇研修',
  'corporateResidence.jsonld.areaServed': '日本',
  'corporateResidence.jsonld.description': '高級レジデンス向け研修。コンシェルジュ・フロントの接遇品質を執事の基準で統一。1日330,000円税込〜、全国出張。入居者満足の向上を接遇品質から支援します。',
  'corporateResidence.jsonld.breadcrumb1': 'ホーム',
  'corporateResidence.jsonld.breadcrumb2': '法人研修',
  'corporateResidence.jsonld.breadcrumb3': '高級レジデンス向け',
  'corporateResidence.hero.homeLink': 'ホーム',
  'corporateResidence.hero.corporateLink': '法人研修',
  'corporateResidence.hero.currentPage': '高級レジデンス向け',
  'corporateResidence.hero.title': '高級レジデンス向け 法人研修',
  'corporateResidence.hero.titleEn': 'FOR LUXURY RESIDENCES',
  'corporateResidence.hero.lead': '高級レジデンス向け研修は、コンシェルジュとフロントの接遇を執事の基準で統一する日本の執事学校のプログラムです。',
  'corporateResidence.hero.ctaBtn': 'この業種で相談する',
  'corporateResidence.hero.imgAlt': '高級レジデンスのエントランスで入居者を迎えるコンシェルジュ',
  'corporateResidence.hero.badge1': '入居者満足を接遇品質から支える',
  'corporateResidence.hero.badge2': '出張型で貴物件の現場に合わせた訓練',
  'corporateResidence.hero.badge3': '執事養成課程と同一の講師陣',
  'corporateResidence.pain.label': 'CHALLENGES',
  'corporateResidence.pain.title': 'こんな課題をお持ちではありませんか',
  'corporateResidence.pain.subtitleEn': 'Common Challenges',
  'corporateResidence.pain.lead': '高級レジデンス特有の接遇課題に、執事教育のメソッドでお応えします。',
  'corporateResidence.pain.item1': '入居者の皆様が比べる相手は、近隣の物件ではなく一流ホテルの接遇です。日々の挨拶や取次のひとつひとつが、住み心地と物件の評判を静かに左右します。',
  'corporateResidence.pain.item2': '接遇の不満が管理会社への評価や物件の資産価値に直結します。「対応が悪い」という口コミひとつが空室リスクや賃料下落につながりかねません。',
  'corporateResidence.pain.item3': '「どこまでお応えするか」の線引きが担当者ごとに揺れ、一部の入居者に過剰なサービスを提供する一方で、別の方には不足が生じるという不公平が起きています。',
  'corporateResidence.pain.item4': '個人情報・プライバシーへの配慮を仕組みとして徹底したいが、スタッフの意識や経験値に依存しており、統一された基準がないまま運用されています。',
  'corporateResidence.why.label': 'WHY BUTLER TRAINING',
  'corporateResidence.why.title': '執事教育がレジデンスに効く理由',
  'corporateResidence.why.subtitleEn': 'Why Butler Training Works',
  'corporateResidence.why.lead': '執事と高級レジデンス接遇は、長期の信頼関係という本質で一致しています。',
  'corporateResidence.why.item1.title': '長期の信頼関係を築く技術',
  'corporateResidence.why.item1.desc': '執事は「特定の主に長期で仕える」職業であり、毎日顔を合わせる入居者対応と本質的に同じ構造を持っています。お一人おひとりの好みやご事情を理解し、距離感を保ちながら信頼を積み重ねる技術は、まさにレジデンス接遇が求めるものです。',
  'corporateResidence.why.item2.title': '距離感と守秘を技術として教えられる',
  'corporateResidence.why.item2.desc': '「親しすぎず、よそよそしすぎない」距離感と、入居者の個人情報やご依頼内容の守秘は、感覚や性格に任せるのではなく、技術として揃えられます。執事教育のメソッドで、担当者が替わっても品質がぶれない基盤をつくります。',
  'corporateResidence.why.item3.title': '「型」の言語化でシフト制でも品質を揃える',
  'corporateResidence.why.item3.desc': 'お声がけ・取次・案内といった日々の接遇を「型」として言語化し、誰がどのシフトに入っても同じ水準で対応できる仕組みをお渡しします。新人研修の教材としても活用でき、物件ごとの品質差も解消します。',
  'corporateResidence.programs.label': 'RECOMMENDED PROGRAMMES',
  'corporateResidence.programs.title': 'おすすめプラン',
  'corporateResidence.programs.subtitleEn': 'Recommended for Residences',
  'corporateResidence.programs.lead': '貴物件の状況や目標に合わせて、最適なプランをお選びいただけます。',
  'corporateResidence.programs.detailNote': 'モジュールの詳細は',
  'corporateResidence.programs.detailLink': '法人研修総合ページ',
  'corporateResidence.programs.detailSuffix': 'をご覧ください。',
  'corporateResidence.programs.recommended': 'おすすめ',
  'corporateResidence.programs.currency': '円（税込）',
  'corporateResidence.programs.ctaBtn': 'このプランで相談する',
  'corporateResidence.programs.p1.title': '半日プラン例',
  'corporateResidence.programs.p1.duration': '3時間',
  'corporateResidence.programs.p1.modules': 'M1（立ち居振る舞い）＋ M2（VIP・富裕層対応の原則）',
  'corporateResidence.programs.p1.desc': '接遇の基本所作と富裕層対応の原則に集中する短期プランです。まずは試行的に導入したい場合や、既存スタッフのブラッシュアップ研修として適しています。',
  'corporateResidence.programs.p2.title': '1日プラン例',
  'corporateResidence.programs.p2.duration': '6時間',
  'corporateResidence.programs.p2.modules': 'M1 ＋ M2 ＋ M3（お茶出し・応接実技）＋ M4（想定外対応ロールプレイング）',
  'corporateResidence.programs.p2.desc': '所作からVIP対応、ロールプレイングまで、コンシェルジュ・フロント接遇の基盤を1日で網羅する推奨プランです。',
  'corporateResidence.programs.p3.title': '継続プログラム',
  'corporateResidence.programs.p3.duration': '月1回半日 × 6ヶ月',
  'corporateResidence.programs.p3.modules': '新人受け入れと品質維持の定例研修として推奨',
  'corporateResidence.programs.p3.desc': 'シフト制の現場に最適な継続型プランです。新人が着任する月に合わせて開始月を設定でき、定期的な研修で品質を維持しながら、全スタッフに行き渡る体制を整えます。',
  'corporateResidence.scenario.label': 'SCENARIO TRAINING',
  'corporateResidence.scenario.title': 'シナリオ訓練',
  'corporateResidence.scenario.subtitleEn': 'Residence Scenarios',
  'corporateResidence.scenario.lead': 'レジデンスの現場を想定した3つのシナリオで実技を深めます。',
  'corporateResidence.scenario.note': '※シナリオは貴物件の運営ルールに合わせて差し替え可能です。',
  'corporateResidence.scenario.s1.title': 'エントランスでのお出迎えと荷物対応',
  'corporateResidence.scenario.s1.desc': 'お声がけの距離とタイミング、入居者か来訪者かの見極め、荷物の受け取りとお渡し、エレベーターまでの誘導まで、エントランスでの一連の対応を実技で確認します。第一印象を決定づける最重要シーンを、執事の基準で整えます。',
  'corporateResidence.scenario.s2.title': '取次・代行サービスの所作',
  'corporateResidence.scenario.s2.desc': '宅配便の受け取りとお届け、クリーニングの預かりとお戻し、タクシー手配とお見送りなど、日常的に発生する取次業務を、正確さと品格を両立する手順に整えます。一つひとつの所作に「信頼できる」という印象を込める技術を習得します。',
  'corporateResidence.scenario.s3.title': '難しいご要望への対応',
  'corporateResidence.scenario.s3.desc': '規約上お応えできないご依頼に対し、お断りと代替案の組み立てをロールプレイングします。「お断りしても印象を悪くしない」技術と、入居者に納得いただける提案力を訓練し、現場で迷わず対応できる判断軸を身につけます。',
  'corporateResidence.roles.label': 'TARGET ROLES',
  'corporateResidence.roles.title': '対象職種',
  'corporateResidence.roles.subtitleEn': 'Who Should Attend',
  'corporateResidence.roles.lead': '以下の職種の方々に特にお勧めします。',
  'corporateResidence.roles.r1': 'コンシェルジュ',
  'corporateResidence.roles.r2': 'フロントスタッフ',
  'corporateResidence.roles.r3': 'ハウスキーピング窓口',
  'corporateResidence.roles.r4': '管理員',
  'corporateResidence.roles.r5': '運営責任者',
  'corporateResidence.roles.capacity': '推奨12名まで',
  'corporateResidence.roles.capacityNote': '夜勤明け・シフト制への配慮として、同内容の複数回開催に対応いたします。物件内ラウンジ等の共用施設での出張実施も承ります。',
  'corporateResidence.pricing.label': 'PRICING',
  'corporateResidence.pricing.title': '料金プラン',
  'corporateResidence.pricing.subtitleEn': 'Transparent Pricing',
  'corporateResidence.pricing.lead': 'すべて税込価格での明確な料金体系です。貴物件のご予算と目標に合わせてお選びください。',
  'corporateResidence.pricing.header.plan': 'プラン',
  'corporateResidence.pricing.header.duration': '時間',
  'corporateResidence.pricing.header.price': '料金（税込）',
  'corporateResidence.pricing.header.note': '内容',
  'corporateResidence.pricing.recommended': '標準',
  'corporateResidence.pricing.currency': '円',
  'corporateResidence.pricing.plan1.name': '半日プラン',
  'corporateResidence.pricing.plan1.duration': '3時間',
  'corporateResidence.pricing.plan1.note': '2モジュール選択',
  'corporateResidence.pricing.plan2.name': '1日プラン',
  'corporateResidence.pricing.plan2.duration': '6時間',
  'corporateResidence.pricing.plan2.note': '4モジュール選択',
  'corporateResidence.pricing.plan3.name': '2日間パッケージ',
  'corporateResidence.pricing.plan3.duration': '12時間（2日間）',
  'corporateResidence.pricing.plan3.note': '全6モジュール受講可',
  'corporateResidence.pricing.plan4.name': '継続プログラム',
  'corporateResidence.pricing.plan4.duration': '月1回半日 × 6ヶ月',
  'corporateResidence.pricing.plan4.note': '新人受け入れ・品質維持に',
  'corporateResidence.pricing.conditions.title': '共通条件',
  'corporateResidence.pricing.conditions.dispatch': '出張時の交通費は実費別途',
  'corporateResidence.pricing.conditions.capacity': '推奨12名まで。夜勤明け・シフト制への配慮として同内容の複数回開催に対応します',
  'corporateResidence.pricing.conditions.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporateResidence.pricing.conditions.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
  'corporateResidence.pricing.allMenuNote': '2日間パッケージ・覆面サービス診断などの全メニューは',
  'corporateResidence.pricing.allMenuLink': '法人研修総合ページ',
  'corporateResidence.pricing.allMenuSuffix': 'をご覧ください。',
  'corporateResidence.pricing.ctaBtn': '研修について問い合わせる',
  'corporateResidence.flow.label': 'FLOW',
  'corporateResidence.flow.title': 'ご利用の流れ',
  'corporateResidence.flow.subtitleEn': 'From Enquiry to Results',
  'corporateResidence.flow.lead': 'お問い合わせから実施後レポートまで、5つのステップで着実に進めます。',
  'corporateResidence.flow.step1.title': 'お問い合わせ',
  'corporateResidence.flow.step1.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporateResidence.flow.step2.title': 'ヒアリング',
  'corporateResidence.flow.step2.desc': '物件規模・課題・希望時期などをオンラインまたはお電話で伺います。竣工前・開業前の物件はお引渡し前の集中実施にも対応します。',
  'corporateResidence.flow.step3.title': 'プログラム提案・お見積り',
  'corporateResidence.flow.step3.desc': 'ヒアリング内容をもとに、貴物件に最適な研修プログラムとお見積りをご提案します。',
  'corporateResidence.flow.step4.title': '実施',
  'corporateResidence.flow.step4.desc': '出張または来校にて研修を実施します。出張型では物件内ラウンジ等の共用施設で訓練します。',
  'corporateResidence.flow.step5.title': '実施後レポート',
  'corporateResidence.flow.step5.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',
  'corporateResidence.contact.label': 'CONTACT',
  'corporateResidence.contact.title': 'お問い合わせ',
  'corporateResidence.contact.subtitleEn': 'Enquiry Form',
  'corporateResidence.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporateResidence.contact.phoneLead': 'フォームのほか、お電話',
  'corporateResidence.contact.phoneOr': 'またはメール',
  'corporateResidence.contact.phoneAlso': 'でも承ります。',
  'corporateResidence.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporateResidence.contact.company': '物件名・会社名',
  'corporateResidence.contact.company.placeholder': '例: ○○レジデンス',
  'corporateResidence.contact.department': '部署・役職',
  'corporateResidence.contact.department.placeholder': '例: 管理部 コンシェルジュ責任者',
  'corporateResidence.contact.name': 'ご担当者名',
  'corporateResidence.contact.name.placeholder': '例: 執事 太郎',
  'corporateResidence.contact.name.required': '必須',
  'corporateResidence.contact.name.error': 'ご担当者名は必須です',
  'corporateResidence.contact.email': 'メールアドレス',
  'corporateResidence.contact.email.placeholder': '例: taro@example.com',
  'corporateResidence.contact.email.required': '必須',
  'corporateResidence.contact.email.error': 'メールアドレスは必須です',
  'corporateResidence.contact.email.invalid': '有効なメールアドレスを入力してください',
  'corporateResidence.contact.phone': '電話番号',
  'corporateResidence.contact.phone.placeholder': '例: 090-1234-5678',
  'corporateResidence.contact.phone.required': '必須',
  'corporateResidence.contact.phone.error': '電話番号は必須です',
  'corporateResidence.contact.propertyType': '物件種別',
  'corporateResidence.contact.propertyType.required': '必須',
  'corporateResidence.contact.propertyType.error': '物件種別をお選びください',
  'corporateResidence.contact.format': '希望形式',
  'corporateResidence.contact.participants': '想定人数',
  'corporateResidence.contact.participants.placeholder': '例: 5名',
  'corporateResidence.contact.timeline': '検討時期',
  'corporateResidence.contact.timeline.placeholder': '例: 来月、竣工前、未定',
  'corporateResidence.contact.message': 'ご相談内容（任意）',
  'corporateResidence.contact.message.placeholder': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporateResidence.contact.message.error': '500文字以内で入力してください',
  'corporateResidence.contact.submit.error': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporateResidence.contact.submit': 'この内容で送信する',
  'corporateResidence.contact.submitting': '送信中...',
  'corporateResidence.contact.propertyType.select': '選択してください',
  'corporateResidence.contact.propertyType.condominium': '分譲',
  'corporateResidence.contact.propertyType.rental': '賃貸',
  'corporateResidence.contact.propertyType.membership': '会員制',
  'corporateResidence.contact.propertyType.multiple': '複数物件',
  'corporateResidence.contact.format.select': '選択してください',
  'corporateResidence.contact.format.dispatch': '出張',
  'corporateResidence.contact.format.onsite': '来校',
  'corporateResidence.contact.format.undecided': '未定',
  'corporateResidence.faq.label': 'FAQ',
  'corporateResidence.faq.title': 'よくあるご質問',
  'corporateResidence.faq.subtitleEn': 'Frequently Asked Questions',
  'corporateResidence.faq.otherNote': 'その他のご質問はフォームよりお寄せください',
  'corporateResidence.faq.q1': '執事の資格が取れる研修ですか？',
  'corporateResidence.faq.a1': 'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  'corporateResidence.faq.q2': '管理会社経由での発注はできますか？',
  'corporateResidence.faq.a2': 'はい。管理会社様・デベロッパー様いずれからのご依頼にも対応します。請求書払い（銀行振込）で承ります。',
  'corporateResidence.faq.q3': '少人数（2〜3名）のチームでも依頼できますか？',
  'corporateResidence.faq.a3': 'はい、可能です。料金はプラン単位のため人数が少ない場合も同額ですが、その分一人あたりの実技時間を厚く設計します。',
  'corporateResidence.faq.q4': 'シフト制で全員が同日に集まれません。',
  'corporateResidence.faq.a4': '同一内容を複数回に分けて実施する形式をご提案します。回数と日程はヒアリング時にご相談ください。',
  'corporateResidence.cta.label': 'GET STARTED',
  'corporateResidence.cta.title': 'まずはお気軽にご相談ください',
  'corporateResidence.cta.lead': '貴物件の課題をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporateResidence.cta.lead2': '複数物件への展開や月次の継続実施もご提案できます。まずは現状の課題をお聞かせください。',
  'corporateResidence.cta.inquiryBtn': 'この業種で相談する',
  'corporateResidence.cta.coursesBtn': '法人研修トップに戻る',
  'corporateResidence.related.label': 'OTHER INDUSTRIES',
  'corporateResidence.related.title': '他の業種別研修',
  'corporateResidence.related.subtitleEn': 'Other Industry Programmes',
  'corporateResidence.related.backToCorpBtn': '法人研修総合ページへ戻る',
  'corporateResidence.related.coursesBtn': '個人向けコース（執事養成課程）を見る',
  'corporateResidence.related.viewDetail': '詳しく見る',
  'corporateResidence.related.r1.title': 'ホテル・旅館',
  'corporateResidence.related.r1.desc': 'バトラーサービスの型を開業前に整える',
  'corporateResidence.related.r2.title': '金融・プライベートバンク',
  'corporateResidence.related.r2.desc': '富裕層営業の信頼を所作から築く',
  'corporateResidence.related.r3.title': '百貨店外商・高級小売',
  'corporateResidence.related.r3.desc': 'お得意様対応と訪問の作法',
  'corporateResidence.related.r4.title': 'ラグジュアリー営業',
  'corporateResidence.related.r4.desc': '高級車・宝飾・不動産の商談体験を設計',
  'corporateResidence.related.r5.title': '医療・美容クリニック',
  'corporateResidence.related.r5.desc': '自由診療の接遇を院内に定着',
  'corporateResidence.related.r6.title': '自動車・モビリティ',
  'corporateResidence.related.r6.desc': 'ブランド体験の接遇を高める',
  'corporateResidence.related.r7.title': 'ハイヤー・送迎',
  'corporateResidence.related.r7.desc': '乗降の所作と車内の気配りを磨く',
  'corporateResidence.contact.label': 'CONTACT',
  'corporateResidence.contact.title': 'お問い合わせ・資料請求',
  'corporateResidence.contact.subtitleEn': 'ENQUIRY & BROCHURE REQUEST',
  'corporateResidence.contact.lead': 'まずはお気軽にご相談ください。研修内容・料金・スケジュールについて、担当者がご説明いたします。',
  'corporateResidence.contact.phoneLead': 'お電話でのご相談は',
  'corporateResidence.contact.phoneOr': 'またはメール',
  'corporateResidence.contact.phoneAlso': 'でも承ります。',
  'corporateResidence.contact.hours': '受付時間: 平日 9:00〜18:00',
  'corporateResidence.contact.company': '会社名・物件名',
  'corporateResidence.contact.company.placeholder': '例: ○○レジデンス運営株式会社',
  'corporateResidence.contact.department': '部署・役職',
  'corporateResidence.contact.department.placeholder': '例: 総務部 研修担当',
  'corporateResidence.contact.name': 'お名前',
  'corporateResidence.contact.name.required': '必須',
  'corporateResidence.contact.name.placeholder': '例: 山田 太郎',
  'corporateResidence.contact.name.error': 'お名前を入力してください',
  'corporateResidence.contact.email': 'メールアドレス',
  'corporateResidence.contact.email.required': '必須',
  'corporateResidence.contact.email.placeholder': 'example@company.com',
  'corporateResidence.contact.email.error': 'メールアドレスを入力してください',
  'corporateResidence.contact.email.invalid': '正しいメールアドレスを入力してください',
  'corporateResidence.contact.phone': '電話番号',
  'corporateResidence.contact.phone.required': '必須',
  'corporateResidence.contact.phone.placeholder': '例: 03-1234-5678',
  'corporateResidence.contact.phone.error': '電話番号を入力してください',
  'corporateResidence.contact.propertyType': '物件種別',
  'corporateResidence.contact.propertyType.required': '必須',
  'corporateResidence.contact.propertyType.error': '物件種別を選択してください',
  'corporateResidence.contact.propertyType.select': '物件種別を選択してください',
  'corporateResidence.contact.propertyType.condominium': '高級分譲マンション',
  'corporateResidence.contact.propertyType.rental': '高級賃貸マンション',
  'corporateResidence.contact.propertyType.membership': '会員制レジデンス',
  'corporateResidence.contact.propertyType.multiple': '複数物件',
  'corporateResidence.contact.format': '研修形式',
  'corporateResidence.contact.format.select': '研修形式を選択してください',
  'corporateResidence.contact.format.dispatch': '講師派遣（貴社会場）',
  'corporateResidence.contact.format.onsite': '物件内研修（共用施設利用）',
  'corporateResidence.contact.format.undecided': '未定・要相談',
  'corporateResidence.contact.participants': '参加予定人数',
  'corporateResidence.contact.participants.placeholder': '例: 10名',
  'corporateResidence.contact.timeline': '希望時期',
  'corporateResidence.contact.timeline.placeholder': '例: 2026年8月ごろ',
  'corporateResidence.contact.message': 'ご相談内容・備考',
  'corporateResidence.contact.message.placeholder': '研修の背景・課題・ご要望などをご記入ください（500文字以内）',
  'corporateResidence.contact.message.error': 'ご相談内容は500文字以内で入力してください',
  'corporateResidence.contact.submit': '送信する',
  'corporateResidence.contact.submitting': '送信中...',
  'corporateResidence.contact.submit.error': '送信に失敗しました。お電話またはメールにてお問い合わせください。',
};

export default corporateResidence;
